// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JCBN","col":"styles_col__3AI2g"};